<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner v-if="banner.length" :banner="banner[0]" />

    <!-- 面包屑 -->
    <div class="crumbs">
      <div>关于我们 > 协会信息</div>
    </div>

    <div class="ny-tabs">
      <ul>
        <li
          v-for="item in tabList"
          :key="item.name"
          :class="{'action': item.id === parseInt(subType)}"
          @click="$router.push(item.path)"
        >{{ item.name }}</li>
      </ul>
    </div>

    <div class="container-width">
      <!-- <div class="new-list" v-if="pageInfo.total > 0">
        <div class="item" v-for="item in list" :key="item.id">
          <h3 class="mouse" @click="$router.push(`/communist-house/detail?id=${type}-${subType}-${item.id}`)">{{ item.title }}</h3>
          <div>
            {{ item.createTime ? formatDate(Date.parse(item.createTime)) : '' }}
          </div>
          <div class="content">
            {{ item.introduction }}
          </div>
        </div>
      </div> -->
      <div class="new-list" v-if="pageInfo.total > 0">
        <dl v-for="item in list" :key="item.id">
          <dt class="mouse" @click="$router.push(`/communist-house/detail?id=${type}-${subType}-${item.id}`)">
            <!-- <span class="new"></span> -->
            <img width="245" height="158" :src="item.cover" :alt="item.title">
          </dt>
          <dd>
            <h3 class="mouse" @click="$router.push(`/communist-house/detail?id=${type}-${subType}-${item.id}`)">{{ item.title }}</h3>
            <div style="color: #999;">
              {{ item.createTime ? formatDate(Date.parse(item.createTime)) : '' }}
            </div>
            <div class="content">
              {{ item.introduction }}
            </div>
            <span class="detail" @click="$router.push(`/communist-house/detail?id=${type}-${subType}-${item.id}`)">查看详情</span>
          </dd>
        </dl>
      </div>
      <div v-else class="no-list">暂无数据</div>
      <div class="pagination-box" v-if="pageInfo.total > 0">
        <el-pagination
          background
          :page-size="pageInfo.size"
          :total="pageInfo.total"
          @current-change="currentChange"
          layout="prev, pager, next">
        </el-pagination>
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
// import { wenzhang } from '@/page/constants'
import { getBanner } from '@/service/apis/common'
import { getNewsPage } from '@/service/apis/news'

export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'News',
  data() {
    return {
      tabList: [{
        name: '协会信息',
        id: 621,
        path: '/communist-house?type=62-621',
      }, {
        name: '党建园地',
        id: 620,
        path: '/communist-house?type=62-620',
      }],
      type: '62',
      subType: '621',
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      list: [],
      // wenzhang,
      banner: []
    }
  },
  computed: {
    // filterSubtype () {
    //   let list = wenzhang[1].children
    //   let filter = list.filter(item => item.id === parseInt(this.subType))
    //   return filter.length ? filter[0].name : ''
    // }
  },
  watch: {
    '$route.query.type'(val) {
      if (val && val.split('-').length) {
        let arr = val.split('-')
        this.type = arr[0]
        this.subType = arr[1]
        this.getList()
      }
    }
  },
  created() {
    let types = this.$route.query.type
    if (types) {
      let typeArr = types.split('-')
      if (typeArr.length === 2) {
        this.type = typeArr[0]
        this.subType = typeArr[1]
      }
    }
    getBanner(this).then(data => {
      // 新闻资讯 banner 8
      if (data[8]) {
        this.banner = [...data[8]]
      }
    })
    this.getList()
  },
  methods: {
    currentChange (page) {
      this.pageInfo.pageIndex = page
      this.getList()
    },
    getList () {
      let opt = {
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize,
        type: this.type,
        subType: this.subType
      }
      getNewsPage.call(this, opt).then(res => {
        let data = res.data
        this.pageInfo.total = data.total || 0
        this.list = []
        if (data.records && data.records.length) {
          data.records.forEach(item => {
            this.list.push(item)
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.new-list {
  padding: 12px 0;
  height: auto;
  overflow: hidden;
}
.new-list .item {
  border: solid 1px #f2f2f2;
  margin: 12px 0;
  padding: 0 28px;
  width: 100%;
  float: left;
  box-sizing: border-box;
  font-size: 12px;
}
.new-list .item h3 {
  padding-top: 12px;
  line-height: 44px;
  font-size: 30px;
  color: #333;
  font-weight: normal;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  margin-bottom: 6px;
}
.new-list  .item .content {
  margin: 20px 0;
  font-size: 14px;
  height: 56px;
  line-height: 28px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
  transition: color ease .3s;
}

.new-list  .item h3:hover {
  color: #4c2ac9;
}

.new-list  .item .detail {
  font-size: 14px;
  display: block;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  border: solid 1px #ececec;
  transition: all ease .3s;
}
.new-list  .item .detail:hover {
  border-color: #4c2ac9;
  color: #4c2ac9;
}

@media screen and (max-width: 736px) {
  .new-list .item {
    padding: 12px;
  }
  .new-list .item .content {
    height: 48px;
    margin-top: 8px;
    margin-bottom: 0;
    line-height: 24px;
    padding-bottom: 0;
  }
  .new-list .item h3 {
    font-size: 24px;
    line-height: 32px;
    padding-top: 0;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4c2ac9;
}

.no-list {
  height: 400px;
  line-height: 200px;
  color: #666;
  text-align: center;
}
</style>
